export const US_STATES = [
  ["AL","Alabama"],["AK","Alaska"],["AZ","Arizona"],["AR","Arkansas"],["CA","California"],
  ["CO","Colorado"],["CT","Connecticut"],["DE","Delaware"],["FL","Florida"],["GA","Georgia"],
  ["HI","Hawaii"],["ID","Idaho"],["IL","Illinois"],["IN","Indiana"],["IA","Iowa"],
  ["KS","Kansas"],["KY","Kentucky"],["LA","Louisiana"],["ME","Maine"],["MD","Maryland"],
  ["MA","Massachusetts"],["MI","Michigan"],["MN","Minnesota"],["MS","Mississippi"],["MO","Missouri"],
  ["MT","Montana"],["NE","Nebraska"],["NV","Nevada"],["NH","New Hampshire"],["NJ","New Jersey"],
  ["NM","New Mexico"],["NY","New York"],["NC","North Carolina"],["ND","North Dakota"],["OH","Ohio"],
  ["OK","Oklahoma"],["OR","Oregon"],["PA","Pennsylvania"],["RI","Rhode Island"],["SC","South Carolina"],
  ["SD","South Dakota"],["TN","Tennessee"],["TX","Texas"],["UT","Utah"],["VT","Vermont"],
  ["VA","Virginia"],["WA","Washington"],["WV","West Virginia"],["WI","Wisconsin"],["WY","Wyoming"],
  ["DC","District of Columbia"],
];

export const ROTATION_LEVELS = [
  "Level 1 No Hands On",
  "Level 1 Hands On",
  "Level 2",
  "Capstone No Treatment",
];

export const SCHOOL_USER_TITLES = [
  "Program Director",
  "Fieldwork Coordinator/CE",
  "Instructor",
  "Career Services Contact",
  "DOR",
  "AM",
];

export const SCHOOL_CONTACT_ROLES = [
  ["program_director", "Program Director"],
  ["fieldwork_coordinator", "Fieldwork Coordinator/CE"],
  ["instructor", "Instructor"],
  ["career_services", "Career Services Contact"],
];


// Roles with full Campus Coordinator privileges (Supervisor inherits everything a CC can do).
export const CC_ROLES = ["Super Admin", "Campus Coordinator", "Campus Coordinator Supervisor"];
export const isCoordinator = (role) => CC_ROLES.includes(role);
